import routes from 'routes/documents'

const Documents = () =>
  routes

export default Documents